import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export const useAuthRedirect = (path: string, redirectUrl: string) => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname === path) {
      const searchParams = new URLSearchParams(location.search)
      const token = searchParams.get("token")

      const newSearchParams = new URLSearchParams()
      if (token) {
        newSearchParams.append("token", token)
      }
      newSearchParams.append("redirectUrl", redirectUrl)

      navigate(`/auth?${newSearchParams.toString()}`, { replace: true })
    }
  }, [location, navigate, path])
}
